module.exports = __webpack_public_path__ + "img/success.e9f913e6.gif";